(function () {
  'use strict';

  var LEGACY_PROFILE_KEY = 'ccNutritionProfileV1';
  var LEGACY_MEASUREMENTS_KEY = 'ccNutritionMeasurementsV1';

  document.querySelectorAll('[data-nutrition-coach]').forEach(function (root) {
    var app = root.querySelector('[data-coach-app]');
    if (!app) return;

    var memberId = root.dataset.memberId || 'member';
    var PROFILE_KEY = 'ccNutritionProfileV2:' + memberId;
    var MEASUREMENTS_KEY = 'ccNutritionMeasurementsV2:' + memberId;
    var nutritionForm = root.querySelector('[data-nutrition-form]');
    var workspace = root.querySelector('[data-intake-workspace]');
    var results = root.querySelector('[data-plan-results]');
    var standardPlan = root.querySelector('[data-standard-plan]');
    var clinicalHold = root.querySelector('[data-clinical-hold]');
    var formError = root.querySelector('[data-form-error]');
    var saveStatus = root.querySelector('[data-save-status]');
    var currentStep = 1;
    var lastPlan = null;
    var lastReview = null;
    var measurementEntries = readMeasurements();

    function readStorage(storage, key) {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function writeStorage(storage, key, value) {
      try {
        storage.setItem(key, value);
        return true;
      } catch (error) {
        return false;
      }
    }

    function removeStorage(storage, key) {
      try {
        storage.removeItem(key);
      } catch (error) {
        return;
      }
    }

    function readMeasurements() {
      var raw = readStorage(window.localStorage, MEASUREMENTS_KEY);
      if (!raw) {
        raw = readStorage(window.localStorage, LEGACY_MEASUREMENTS_KEY);
        if (raw && writeStorage(window.localStorage, MEASUREMENTS_KEY, raw)) {
          removeStorage(window.localStorage, LEGACY_MEASUREMENTS_KEY);
        }
      }
      if (!raw) return [];
      try {
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter(function (entry) {
          return entry && /^\d{4}-\d{2}-\d{2}$/.test(entry.date || '') && Number(entry.waistCm) > 0;
        }).slice(0, 24);
      } catch (error) {
        return [];
      }
    }

    function saveMeasurements() {
      return writeStorage(window.localStorage, MEASUREMENTS_KEY, JSON.stringify(measurementEntries.slice(0, 24)));
    }

    function showApp() {
      app.hidden = false;

      var saved = readStorage(window.localStorage, PROFILE_KEY);
      if (!saved) {
        saved = readStorage(window.localStorage, LEGACY_PROFILE_KEY);
        if (saved && writeStorage(window.localStorage, PROFILE_KEY, saved)) {
          removeStorage(window.localStorage, LEGACY_PROFILE_KEY);
        }
      }
      if (saved) {
        try {
          restoreForm(JSON.parse(saved));
          buildPlan(true);
          return;
        } catch (error) {
          removeStorage(window.localStorage, PROFILE_KEY);
        }
      }

      showStep(1);
      workspace.hidden = false;
      results.hidden = true;
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    root.querySelector('[data-start-again]').addEventListener('click', function () {
      removeStorage(window.localStorage, PROFILE_KEY);
      nutritionForm.reset();
      lastPlan = null;
      updateUnits('metric', false);
      updateGoalControls();
      showStep(1);
      results.hidden = true;
      workspace.hidden = false;
      formError.textContent = '';
      window.scrollTo({ top: app.offsetTop, behavior: 'smooth' });
    });

    function showStep(step, keepError) {
      currentStep = Math.max(1, Math.min(4, step));

      root.querySelectorAll('[data-step]').forEach(function (panel) {
        panel.hidden = Number(panel.dataset.step) !== currentStep;
      });

      root.querySelectorAll('[data-step-jump]').forEach(function (button) {
        var buttonStep = Number(button.dataset.stepJump);
        button.classList.toggle('is-active', buttonStep === currentStep);
        button.classList.toggle('is-complete', buttonStep < currentStep);
      });

      root.querySelector('[data-progress-status]').textContent = 'Step ' + currentStep + ' of 4';
      root.querySelector('[data-previous-step]').hidden = currentStep === 1;
      root.querySelector('[data-next-step]').hidden = currentStep === 4;
      root.querySelector('[data-build-plan]').hidden = currentStep !== 4;
      if (!keepError) formError.textContent = '';
    }

    root.querySelectorAll('[data-step-jump]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = Number(button.dataset.stepJump);
        if (target > currentStep && !validateStep(currentStep)) return;
        showStep(target);
      });
    });

    root.querySelector('[data-next-step]').addEventListener('click', function () {
      if (!validateStep(currentStep)) return;
      showStep(currentStep + 1);
    });

    root.querySelector('[data-previous-step]').addEventListener('click', function () {
      showStep(currentStep - 1);
    });

    nutritionForm.querySelectorAll('input[name="units"]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateUnits(input.value, true);
      });
    });

    nutritionForm.querySelectorAll('input[name="goal"]').forEach(function (input) {
      input.addEventListener('change', updateGoalControls);
    });

    function updateUnits(units, convert) {
      var metricFields = root.querySelector('[data-metric-fields]');
      var imperialFields = root.querySelector('[data-imperial-fields]');

      if (convert && units === 'imperial') {
        var heightCm = numberValue('heightCm');
        var weightKg = numberValue('weightKg');
        var targetKg = numberValue('targetKg');
        if (heightCm) {
          var totalInches = heightCm / 2.54;
          setValue('heightFt', Math.floor(totalInches / 12));
          setValue('heightIn', Math.round(totalInches % 12));
        }
        if (weightKg) setValue('weightLb', Math.round(weightKg * 2.20462));
        if (targetKg) setValue('targetLb', Math.round(targetKg * 2.20462));
      }

      if (convert && units === 'metric') {
        var feet = numberValue('heightFt');
        var inches = numberValue('heightIn');
        var weightLb = numberValue('weightLb');
        var targetLb = numberValue('targetLb');
        if (feet) setValue('heightCm', Math.round(((feet * 12) + inches) * 2.54));
        if (weightLb) setValue('weightKg', (weightLb / 2.20462).toFixed(1));
        if (targetLb) setValue('targetKg', (targetLb / 2.20462).toFixed(1));
      }

      metricFields.hidden = units !== 'metric';
      imperialFields.hidden = units !== 'imperial';
    }

    function updateGoalControls() {
      var goal = checkedValue('goal') || 'loss';
      var pace = nutritionForm.elements.pace;
      var paceField = pace.closest('.ccn-field');

      if (goal === 'maintain') {
        pace.value = 'standard';
        paceField.hidden = true;
        return;
      }

      paceField.hidden = false;
      if (goal === 'build') {
        pace.options[0].textContent = 'Conservative - 5% surplus';
        pace.options[1].textContent = 'Standard - 7.5% surplus';
        pace.options[2].textContent = 'Assertive - 10% surplus';
      } else {
        pace.options[0].textContent = 'Gentle - 10% deficit';
        pace.options[1].textContent = 'Standard - 15% deficit';
        pace.options[2].textContent = 'Assertive - 20% deficit';
      }
    }

    function checkedValue(name) {
      var input = nutritionForm.querySelector('input[name="' + name + '"]:checked');
      return input ? input.value : '';
    }

    function numberValue(name) {
      var element = nutritionForm.elements[name];
      if (!element || element.value === '') return 0;
      return Number(element.value);
    }

    function setValue(name, value) {
      var element = nutritionForm.elements[name];
      if (element) element.value = value;
    }

    function inRange(value, min, max) {
      return Number.isFinite(value) && value >= min && value <= max;
    }

    function validateStep(step) {
      formError.textContent = '';

      if (step === 1) {
        var units = checkedValue('units');
        var age = numberValue('age');
        var validBody = inRange(age, 18, 80);

        if (units === 'metric') {
          validBody = validBody && inRange(numberValue('heightCm'), 120, 230) && inRange(numberValue('weightKg'), 35, 300);
        } else {
          validBody = validBody && inRange(numberValue('heightFt'), 3, 7) && inRange(numberValue('heightIn'), 0, 11) && inRange(numberValue('weightLb'), 77, 660);
        }

        if (!validBody) {
          formError.textContent = 'Check your age, height and current weight before continuing.';
          return false;
        }
      }

      if (step === 2) {
        if (!inRange(numberValue('trainingDays'), 0, 14) || !inRange(numberValue('longSessions'), 0, 14) || !inRange(numberValue('sleep'), 3, 12)) {
          formError.textContent = 'Check your training frequency, long sessions and sleep before continuing.';
          return false;
        }
      }

      if (step === 3) {
        if (!inRange(numberValue('produce'), 0, 15) || !inRange(numberValue('fluids'), 0, 30) || !inRange(numberValue('alcohol'), 0, 100) || !inRange(numberValue('takeaways'), 0, 21)) {
          formError.textContent = 'Check the food and drink numbers before continuing.';
          return false;
        }
      }

      if (step === 4 && !nutritionForm.elements.understanding.checked) {
        formError.textContent = 'Confirm that you understand the purpose and limits of the tool.';
        return false;
      }

      return true;
    }

    function validateAllSteps() {
      for (var step = 1; step <= 4; step += 1) {
        if (!validateStep(step)) {
          var message = formError.textContent;
          showStep(step, true);
          formError.textContent = message;
          return false;
        }
      }
      return true;
    }

    function collectProfile() {
      var units = checkedValue('units') || 'metric';
      var heightCm;
      var weightKg;
      var targetKg;

      if (units === 'metric') {
        heightCm = numberValue('heightCm');
        weightKg = numberValue('weightKg');
        targetKg = numberValue('targetKg');
      } else {
        heightCm = ((numberValue('heightFt') * 12) + numberValue('heightIn')) * 2.54;
        weightKg = numberValue('weightLb') / 2.20462;
        targetKg = numberValue('targetLb') ? numberValue('targetLb') / 2.20462 : 0;
      }

      return {
        firstName: nutritionForm.elements.firstName.value.trim().slice(0, 40),
        age: numberValue('age'),
        sex: checkedValue('sex') || 'male',
        units: units,
        heightCm: heightCm,
        weightKg: weightKg,
        targetKg: targetKg,
        goal: checkedValue('goal') || 'loss',
        pace: nutritionForm.elements.pace.value || 'standard',
        activity: Number(nutritionForm.elements.activity.value),
        trainingFocus: nutritionForm.elements.trainingFocus.value,
        trainingDays: numberValue('trainingDays'),
        longSessions: numberValue('longSessions'),
        trainingTime: nutritionForm.elements.trainingTime.value,
        meals: Number(nutritionForm.elements.meals.value),
        sleep: numberValue('sleep'),
        dietPattern: nutritionForm.elements.dietPattern.value,
        trackingStyle: nutritionForm.elements.trackingStyle.value,
        cookingTime: nutritionForm.elements.cookingTime.value,
        budget: nutritionForm.elements.budget.value,
        produce: numberValue('produce'),
        fluids: numberValue('fluids'),
        alcohol: numberValue('alcohol'),
        takeaways: numberValue('takeaways'),
        appetite: nutritionForm.elements.appetite.value,
        friction: nutritionForm.elements.friction.value,
        restrictions: nutritionForm.elements.restrictions.value.trim().slice(0, 300),
        clinical: checkedValue('clinical') || 'no'
      };
    }

    function roundToTen(value) {
      return Math.round(value / 10) * 10;
    }

    function roundToFive(value) {
      return Math.max(0, Math.round(value / 5) * 5);
    }

    function clamp(value, minimum, maximum) {
      return Math.min(Math.max(value, minimum), maximum);
    }

    function formatNumber(value) {
      return Math.round(value).toLocaleString('en-GB');
    }

    function calculatePlan(profile) {
      var heightM = profile.heightCm / 100;
      var bmi = profile.weightKg / (heightM * heightM);
      var targetBmi = profile.targetKg ? profile.targetKg / (heightM * heightM) : 0;
      var clinicalReasons = [];

      if (profile.clinical === 'yes') clinicalReasons.push('You selected a clinical or specialist-diet factor.');
      if (bmi < 18.5) clinicalReasons.push('Your current BMI is below the range where a generic body-composition target is appropriate.');
      if (targetBmi && targetBmi < 18.5) clinicalReasons.push('The target weight entered falls below a BMI of 18.5.');

      var bmr = (10 * profile.weightKg) + (6.25 * profile.heightCm) - (5 * profile.age) + (profile.sex === 'male' ? 5 : -161);
      var maintenance = roundToTen(bmr * profile.activity);
      var factor = 1;
      var warnings = [];

      if (profile.goal === 'loss') {
        var deficits = { gentle: 0.10, standard: 0.15, assertive: 0.20 };
        var deficit = deficits[profile.pace] || 0.15;
        if ((bmi < 23 || profile.longSessions >= 3) && deficit > 0.15) {
          deficit = 0.15;
          warnings.push('The requested deficit was reduced to protect training quality and lean mass.');
        }
        factor = 1 - deficit;
      }

      if (profile.goal === 'build') {
        var surpluses = { gentle: 0.05, standard: 0.075, assertive: 0.10 };
        var surplus = surpluses[profile.pace] || 0.075;
        if (bmi >= 30) {
          surplus = 0;
          warnings.push('The starting target is maintenance rather than a surplus. Progress training while body composition stabilises.');
        }
        factor = 1 + surplus;
      }

      var calories = roundToTen(maintenance * factor);
      if (calories < 1200) clinicalReasons.push('The calculated target is below 1,200 kcal, which needs specialist oversight rather than an automated plan.');

      if (clinicalReasons.length) {
        return {
          clinical: true,
          profile: profile,
          bmi: bmi,
          reasons: clinicalReasons
        };
      }

      var referenceWeight = profile.weightKg;
      if (profile.goal === 'loss' && profile.targetKg && profile.targetKg < profile.weightKg) {
        referenceWeight = profile.targetKg;
      } else if (bmi > 30) {
        referenceWeight = Math.min(profile.weightKg, 27.5 * heightM * heightM);
        warnings.push('Protein is based on a height-adjusted reference weight so the target is not overstated.');
      }

      var proteinFactors = {
        strength: 2.0,
        endurance: 1.6,
        mixed: 1.8,
        combat: 1.8,
        general: 1.6
      };
      var proteinFactor = proteinFactors[profile.trainingFocus] || 1.8;
      if (profile.goal === 'loss') proteinFactor = Math.min(2.2, proteinFactor + 0.2);
      if (profile.goal === 'build') proteinFactor = Math.max(1.8, proteinFactor);

      var protein = roundToFive(referenceWeight * proteinFactor);
      var fatFloor = referenceWeight * 0.7;
      var fatFromEnergy = (calories * 0.25) / 9;
      var fatCeiling = (calories * 0.35) / 9;
      var fat = roundToFive(Math.min(Math.max(fatFloor, fatFromEnergy), fatCeiling));
      var carbohydrates = roundToFive((calories - (protein * 4) - (fat * 9)) / 4);

      if (carbohydrates < 80) {
        fat = roundToFive((calories * 0.22) / 9);
        carbohydrates = roundToFive((calories - (protein * 4) - (fat * 9)) / 4);
        warnings.push('Fat was held near the lower end of the recommended range to protect carbohydrate availability.');
      }

      var carbsPerKg = carbohydrates / profile.weightKg;
      if (profile.trainingDays >= 4 && carbsPerKg < 2) {
        warnings.push('Carbohydrate availability is low for your training frequency. Watch performance, recovery and mood closely.');
      }

      if (profile.goal === 'loss' && calories <= 1500) {
        warnings.push('This is a low starting intake. Review hunger, sleep, recovery and adherence with your coach before reducing further.');
      }

      var weeklyKg = Math.abs(maintenance - calories) * 7 / 7700;
      var weeklyPercent = (weeklyKg / profile.weightKg) * 100;
      var mealProtein = Math.round(protein / profile.meals);
      var rangeLow = calories - 100;
      var rangeHigh = calories + 100;

      return {
        clinical: false,
        profile: profile,
        bmi: bmi,
        bmr: bmr,
        maintenance: maintenance,
        calories: calories,
        rangeLow: rangeLow,
        rangeHigh: rangeHigh,
        protein: protein,
        carbohydrates: carbohydrates,
        fat: fat,
        proteinFactor: proteinFactor,
        mealProtein: mealProtein,
        weeklyKg: weeklyKg,
        weeklyPercent: weeklyPercent,
        warnings: warnings
      };
    }

    function createCard(item, className, index) {
      var card = document.createElement('article');
      card.className = className;
      var number = document.createElement('span');
      number.textContent = String(index + 1).padStart(2, '0');
      var title = document.createElement('h4');
      title.textContent = item.title;
      var copy = document.createElement('p');
      copy.textContent = item.copy;
      card.append(number, title, copy);
      return card;
    }

    function renderCards(container, items, className) {
      container.textContent = '';
      items.forEach(function (item, index) {
        container.appendChild(createCard(item, className, index));
      });
    }

    function foodBankFor(pattern, budget) {
      var proteins = {
        omnivore: ['Eggs', 'Chicken thighs or breast', 'Lean mince', 'Greek yoghurt or cottage cheese', 'Tinned tuna or salmon', 'Beans and lentils'],
        pescatarian: ['Eggs', 'Greek yoghurt or cottage cheese', 'Tinned tuna or salmon', 'White fish', 'Prawns', 'Tofu, beans and lentils'],
        vegetarian: ['Eggs', 'Greek yoghurt or cottage cheese', 'Tofu and tempeh', 'Quorn or seitan', 'Beans and lentils', 'Protein-fortified dairy alternatives'],
        vegan: ['Tofu and tempeh', 'Seitan', 'Soya mince', 'Beans and lentils', 'Edamame', 'Soya yoghurt and plant protein']
      };
      var proteinList = proteins[pattern] || proteins.omnivore;

      if (budget === 'tight') {
        proteinList = pattern === 'vegan'
          ? ['Dried lentils', 'Beans and chickpeas', 'Tofu', 'Soya mince', 'Peas', 'Value plant protein']
          : ['Eggs', 'Chicken thighs', 'Tinned fish', 'Lean frozen mince', 'Greek-style yoghurt', 'Beans and lentils'];
      }

      return [
        { title: 'Protein anchors', items: proteinList },
        { title: 'Carbohydrate base', items: ['Oats', 'Rice', 'Potatoes', 'Wholegrain bread or wraps', 'Pasta', 'Fruit'] },
        { title: 'Plants and fibre', items: ['Frozen mixed vegetables', 'Leafy greens', 'Peppers and tomatoes', 'Berries or apples', 'Beans and pulses', 'Wholegrains'] },
        { title: 'Useful fats', items: ['Olive or rapeseed oil', 'Nuts and seeds', 'Avocado', 'Nut butter', 'Oily fish or algae source', 'Eggs'] }
      ];
    }

    function renderFoodBank(plan) {
      var container = root.querySelector('[data-food-bank]');
      var banks = foodBankFor(plan.profile.dietPattern, plan.profile.budget);
      container.textContent = '';
      var heading = document.createElement('h4');
      heading.textContent = 'Food bank';
      var columns = document.createElement('div');
      columns.className = 'ccn-food-columns';

      banks.forEach(function (bank) {
        var column = document.createElement('section');
        column.className = 'ccn-food-column';
        var title = document.createElement('h5');
        title.textContent = bank.title;
        var list = document.createElement('ul');
        bank.items.forEach(function (food) {
          var item = document.createElement('li');
          item.textContent = food;
          list.appendChild(item);
        });
        column.append(title, list);
        columns.appendChild(column);
      });

      container.append(heading, columns);
    }

    function proteinReferenceFor(pattern) {
      var foods = {
        chicken: { name: 'Chicken breast, grilled, skinless', kcal: 148, protein: 32.0, carbs: 0, fat: 2.2 },
        beef: { name: 'Extra-lean beef mince, stewed', kcal: 137, protein: 24.7, carbs: 0, fat: 4.2 },
        salmon: { name: 'Farmed salmon, baked', kcal: 232, protein: 25.2, carbs: 0, fat: 14.6 },
        cod: { name: 'Cod, baked', kcal: 100, protein: 23.9, carbs: 0, fat: 0.5 },
        tuna: { name: 'Tuna in brine, drained', kcal: 109, protein: 24.9, carbs: 0, fat: 1.0 },
        prawns: { name: 'King prawns, grilled', kcal: 102, protein: 23.5, carbs: 0, fat: 0.9 },
        eggs: { name: 'Whole eggs, boiled', kcal: 143, protein: 14.1, carbs: '<0.1', fat: 9.6 },
        cottage: { name: 'Reduced-fat cottage cheese', kcal: 68, protein: 10.6, carbs: 3.3, fat: 1.5 },
        quorn: { name: 'Quorn pieces, as purchased', kcal: 73, protein: 14.0, carbs: 1.1, fat: 1.4 },
        tofu: { name: 'Tofu, steamed', kcal: 73, protein: 8.1, carbs: 0.7, fat: 4.2 },
        tempeh: { name: 'Tempeh', kcal: 166, protein: 20.7, carbs: 6.4, fat: 6.4 },
        lentils: { name: 'Green or brown lentils, boiled', kcal: 92, protein: 7.8, carbs: 14.5, fat: 0.7 },
        edamame: { name: 'Edamame, boiled', kcal: 142, protein: 12.2, carbs: 6.5, fat: 7.6 },
        chickpeas: { name: 'Chickpeas, canned and drained', kcal: 129, protein: 8.4, carbs: 18.3, fat: 3.0 }
      };
      var groups = {
        omnivore: ['chicken', 'beef', 'salmon', 'tuna', 'eggs', 'cottage'],
        pescatarian: ['salmon', 'cod', 'tuna', 'prawns', 'eggs', 'cottage'],
        vegetarian: ['eggs', 'cottage', 'quorn', 'tofu', 'tempeh', 'lentils'],
        vegan: ['tofu', 'tempeh', 'edamame', 'lentils', 'chickpeas']
      };
      return (groups[pattern] || groups.omnivore).map(function (key) { return foods[key]; });
    }

    function renderProteinReference(plan) {
      var body = root.querySelector('[data-protein-reference]');
      body.textContent = '';
      proteinReferenceFor(plan.profile.dietPattern).forEach(function (food) {
        var row = document.createElement('tr');
        [food.name, food.kcal, food.protein + 'g', food.carbs + 'g', food.fat + 'g'].forEach(function (value, index) {
          var cell = document.createElement(index === 0 ? 'th' : 'td');
          if (index === 0) cell.setAttribute('scope', 'row');
          cell.textContent = value;
          row.appendChild(cell);
        });
        body.appendChild(row);
      });
    }

    function renderMealBuilder(plan) {
      root.querySelector('[data-meal-builder-copy]').textContent = 'Aim for roughly ' + plan.mealProtein + 'g protein at each of your ' + plan.profile.meals + ' daily feedings, then adjust carbohydrate and fat to the day.';

      var steps = [
        { title: 'Choose protein first', copy: 'Select a protein anchor and portion it to deliver about ' + plan.mealProtein + 'g protein.' },
        { title: 'Choose one flavour', copy: 'Use a repeatable seasoning combination so simple meals do not become bland meals.' },
        { title: 'Add carbohydrate', copy: 'Use a larger portion before or after hard training and a smaller portion when demand is lower.' },
        { title: 'Finish the plate', copy: 'Add fruit or vegetables, then measure oils, dressings, nuts, cheese or other calorie-dense fats.' }
      ];
      var stepList = root.querySelector('[data-meal-builder-steps]');
      stepList.textContent = '';
      steps.forEach(function (step) {
        var item = document.createElement('li');
        var title = document.createElement('strong');
        var copy = document.createElement('span');
        title.textContent = step.title;
        copy.textContent = step.copy;
        item.append(title, copy);
        stepList.appendChild(item);
      });

      var rotations = [
        { title: 'Mediterranean', copy: 'Lemon, garlic, oregano and black pepper.' },
        { title: 'Smoky', copy: 'Smoked paprika, cumin, garlic and chilli.' },
        { title: 'Ginger and lime', copy: 'Ginger, garlic, lime and soy sauce. Count sauces when tracking and keep sodium reasonably consistent.' }
      ];
      var flavours = root.querySelector('[data-flavour-rotations]');
      flavours.textContent = '';
      rotations.forEach(function (rotation) {
        var card = document.createElement('article');
        var title = document.createElement('h5');
        var copy = document.createElement('p');
        title.textContent = rotation.title;
        copy.textContent = rotation.copy;
        card.append(title, copy);
        flavours.appendChild(card);
      });
    }

    function renderCalorieCycling(plan) {
      var container = root.querySelector('[data-calorie-cycles]');
      var weeklyTotal = plan.calories * 7;
      var schedules = [
        {
          title: 'Even intake',
          schedule: formatNumber(plan.calories) + ' kcal on all 7 days',
          note: 'Best when routine and appetite are similar each day.'
        }
      ];

      function addCycle(title, desiredIncrease, note) {
        var maximumIncrease = Math.floor((((plan.calories - 1200) * 5) / 2) / 10) * 10;
        var increase = Math.min(desiredIncrease, maximumIncrease);
        if (increase < 50) return;
        var high = plan.calories + increase;
        var low = (weeklyTotal - (high * 2)) / 5;
        schedules.push({
          title: title,
          schedule: '2 days at ' + formatNumber(high) + ' kcal + 5 days at ' + formatNumber(low) + ' kcal',
          note: note
        });
      }

      addCycle('Training-day bias', 200, 'Put the higher days on the two hardest sessions. Keep protein steady and move mainly carbohydrate.');
      addCycle('Weekend or social bias', 250, 'Use the higher days where they help adherence. Plan them; do not treat them as untracked days.');

      container.textContent = '';
      schedules.forEach(function (schedule) {
        var card = document.createElement('article');
        var title = document.createElement('h5');
        var scheduleLine = document.createElement('strong');
        var note = document.createElement('p');
        var total = document.createElement('small');
        title.textContent = schedule.title;
        scheduleLine.textContent = schedule.schedule;
        note.textContent = schedule.note;
        total.textContent = 'Weekly total: ' + formatNumber(weeklyTotal) + ' kcal';
        card.append(title, scheduleLine, note, total);
        container.appendChild(card);
      });
    }

    function localDateValue() {
      var now = new Date();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      return now.getFullYear() + '-' + month + '-' + day;
    }

    function formatMeasurementDate(value) {
      var date = new Date(value + 'T00:00:00');
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    }

    function measurementFromCm(value, units) {
      if (!value) return 0;
      return units === 'imperial' ? value / 2.54 : value;
    }

    function measurementToCm(value, units) {
      return units === 'imperial' ? value * 2.54 : value;
    }

    function displayMeasurement(value, units) {
      if (!value) return '-';
      return measurementFromCm(value, units).toFixed(1) + (units === 'imperial' ? ' in' : ' cm');
    }

    function waistRatioGuidance(ratio, plan) {
      if (plan.bmi >= 35) {
        return 'Ratio ' + ratio.toFixed(2) + '. NICE uses this screening classification primarily when BMI is below 35; ask a clinician for a fuller risk assessment.';
      }
      if (ratio < 0.4) return 'Ratio ' + ratio.toFixed(2) + '. This is below the NICE classification range; do not treat a lower number as automatically better.';
      if (ratio < 0.5) return 'Ratio ' + ratio.toFixed(2) + '. This sits in the NICE healthy central-adiposity screening range.';
      if (ratio < 0.6) return 'Ratio ' + ratio.toFixed(2) + '. NICE classifies this as increased central adiposity; consider a health-risk review with a clinician.';
      return 'Ratio ' + ratio.toFixed(2) + '. NICE classifies this as high central adiposity; arrange a health-risk review with a clinician.';
    }

    function renderMeasurementTracker(plan) {
      var units = plan.profile.units;
      var unitLabel = units === 'imperial' ? '(in)' : '(cm)';
      root.querySelectorAll('[data-measurement-unit]').forEach(function (label) {
        label.textContent = unitLabel;
      });

      var form = root.querySelector('[data-measurement-form]');
      form.elements.measurementDate.max = localDateValue();
      if (!form.elements.measurementDate.value) form.elements.measurementDate.value = localDateValue();

      ['waist', 'chest', 'hips', 'upperArm', 'thigh'].forEach(function (name) {
        var input = form.elements[name];
        var metricMinimum = name === 'upperArm' || name === 'thigh' ? 10 : 20;
        var metricMaximum = name === 'upperArm' ? 100 : (name === 'thigh' ? 150 : 300);
        input.min = units === 'imperial' ? (metricMinimum / 2.54).toFixed(1) : metricMinimum;
        input.max = units === 'imperial' ? (metricMaximum / 2.54).toFixed(1) : metricMaximum;
      });

      var ordered = measurementEntries.slice().sort(function (a, b) { return b.date.localeCompare(a.date); });
      var measurementDetails = root.querySelector('[data-measurements-details]');
      var summary = root.querySelector('[data-measurement-summary]');
      var historyWrap = root.querySelector('[data-measurement-history-wrap]');
      var history = root.querySelector('[data-measurement-history]');
      summary.textContent = '';
      history.textContent = '';

      if (!ordered.length) {
        summary.hidden = true;
        historyWrap.hidden = true;
        return;
      }

      if (measurementDetails) measurementDetails.open = true;

      var latest = ordered[0];
      var previous = ordered[1] || null;
      var ratio = latest.waistCm / plan.profile.heightCm;
      var heading = document.createElement('h5');
      var ratioValue = document.createElement('strong');
      var guidance = document.createElement('p');
      heading.textContent = 'Latest: ' + formatMeasurementDate(latest.date);
      ratioValue.textContent = 'Waist-to-height ' + ratio.toFixed(2);
      guidance.textContent = waistRatioGuidance(ratio, plan);
      summary.append(heading, ratioValue, guidance);

      if (previous) {
        var changes = document.createElement('ul');
        var fields = [
          { key: 'waistCm', label: 'Waist' },
          { key: 'chestCm', label: 'Chest' },
          { key: 'hipsCm', label: 'Hips' },
          { key: 'upperArmCm', label: 'Upper arm' },
          { key: 'thighCm', label: 'Thigh' }
        ];
        fields.forEach(function (field) {
          if (!latest[field.key] || !previous[field.key]) return;
          var difference = measurementFromCm(latest[field.key] - previous[field.key], units);
          var item = document.createElement('li');
          item.textContent = field.label + ' ' + (difference > 0 ? '+' : '') + difference.toFixed(1) + (units === 'imperial' ? ' in' : ' cm');
          changes.appendChild(item);
        });
        if (changes.children.length) summary.appendChild(changes);
      }
      summary.hidden = false;

      ordered.forEach(function (entry) {
        var row = document.createElement('tr');
        var entryRatio = entry.waistCm / plan.profile.heightCm;
        [
          formatMeasurementDate(entry.date),
          displayMeasurement(entry.waistCm, units),
          displayMeasurement(entry.chestCm, units),
          displayMeasurement(entry.hipsCm, units),
          displayMeasurement(entry.upperArmCm, units),
          displayMeasurement(entry.thighCm, units),
          entryRatio.toFixed(2)
        ].forEach(function (value, index) {
          var cell = document.createElement(index === 0 ? 'th' : 'td');
          if (index === 0) cell.setAttribute('scope', 'row');
          cell.textContent = value;
          row.appendChild(cell);
        });
        history.appendChild(row);
      });
      historyWrap.hidden = false;
    }

    function habitPlan(plan) {
      var profile = plan.profile;
      var habits = [];

      habits.push({
        title: 'Hit the protein floor',
        copy: 'Reach ' + plan.protein + 'g on at least six days each week. Build each meal around a clear protein source.'
      });

      if (profile.produce < 5) {
        habits.push({ title: 'Raise plants gradually', copy: 'Add one fruit or vegetable portion to two reliable meals until you reach at least five portions most days.' });
      }
      if (profile.fluids < 6) {
        habits.push({ title: 'Create a hydration anchor', copy: 'Drink one full glass on waking and one with every meal. Build toward the UK baseline of 6-8 cups, with more for heat and long training.' });
      }
      if (profile.alcohol > 14) {
        habits.push({ title: 'Reduce alcohol exposure', copy: 'Move toward no more than 14 units across the week and schedule alcohol-free days. Alcohol calories still count toward the target.' });
      }
      if (profile.takeaways >= 3) {
        habits.push({ title: 'Control the unplanned meals', copy: 'Pre-decide two default takeaway choices and prepare at least two emergency meals each week.' });
      }
      if (profile.sleep < 7) {
        habits.push({ title: 'Protect sleep before chasing precision', copy: 'Set a repeatable wind-down time and protect a sleep window of at least seven hours where life allows.' });
      }

      var frictionHabits = {
        consistency: { title: 'Use a minimum viable day', copy: 'On busy days, hit calories within range, protein, two plant portions and fluids. Return to the full plan at the next meal.' },
        hunger: { title: 'Engineer satiety', copy: 'Place lean protein, vegetables, fruit, potatoes, oats and high-volume meals earlier in the day. Keep trigger foods portioned rather than forbidden.' },
        planning: { title: 'Plan once, eat repeatedly', copy: 'Choose two breakfasts, two lunches and three evening meals. Shop from that short list before the week starts.' },
        weekends: { title: 'Set the weekend boundary', copy: 'Keep breakfast and lunch structured, decide the social meal in advance, and avoid turning one flexible meal into two flexible days.' },
        portions: { title: 'Make portions visible', copy: 'Plate food before eating, keep calorie-dense extras measured, and pause ten minutes before seconds.' },
        stress: { title: 'Interrupt stress eating', copy: 'Use a ten-minute delay, water and a short walk before deciding to eat. Bring repeated episodes to your coach rather than hiding them.' },
        knowledge: { title: 'Use the four-part meal', copy: 'Build meals from protein, a high-fibre carbohydrate, plants and a measured fat source. Complexity is optional.' }
      };
      habits.push(frictionHabits[profile.friction] || frictionHabits.consistency);

      if (habits.length < 4) {
        habits.push({ title: 'Review the weekly average', copy: 'Record bodyweight 3-7 mornings each week under similar conditions and make decisions from the average, not a single day.' });
      }

      return habits.slice(0, 5);
    }

    function renderHabits(plan) {
      var container = root.querySelector('[data-habit-plan]');
      container.textContent = '';
      habitPlan(plan).slice(0, 3).forEach(function (habit) {
        var item = document.createElement('li');
        var body = document.createElement('div');
        var title = document.createElement('strong');
        var copy = document.createElement('span');
        title.textContent = habit.title;
        copy.textContent = habit.copy;
        body.append(title, copy);
        item.appendChild(body);
        container.appendChild(item);
      });
    }

    function goalLanguage(plan) {
      if (plan.profile.goal === 'loss') {
        return {
          label: 'Fat-loss starting target',
          brief: 'Create a controlled deficit without sacrificing the work.',
          copy: 'The estimated rate is about ' + plan.weeklyPercent.toFixed(2) + '% of bodyweight per week. Hold the range for 14 days before adjusting.'
        };
      }
      if (plan.profile.goal === 'build') {
        return {
          label: 'Muscle-building starting target',
          brief: 'Earn the surplus through progressive training.',
          copy: 'The estimated surplus supports a controlled rate of gain. Strength, waist and weekly average bodyweight decide whether it is working.'
        };
      }
      return {
        label: 'Performance maintenance target',
        brief: 'Fuel repeatable training and stable bodyweight.',
        copy: 'Hold bodyweight within roughly 0.25% while monitoring energy, recovery and performance.'
      };
    }

    function trackingOrder(plan) {
      if (plan.profile.trackingStyle === 'precise') {
        return 'Track intake accurately for 14 days. Weigh calorie-dense foods and use nutrition labels, but judge success from the weekly trend.';
      }
      if (plan.profile.trackingStyle === 'portions') {
        return 'Use repeatable portions: 1-2 palms of protein, 1-2 cupped hands of carbohydrate, 1-2 fists of plants and 1 thumb of fat per main meal.';
      }
      return 'Track calories and protein on uncertain days. On repeatable days, use the same meals and portions without unnecessary logging.';
    }

    function renderStandardPlan(plan) {
      var language = goalLanguage(plan);
      var profile = plan.profile;
      lastReview = null;
      root.querySelector('[data-review-result]').hidden = true;
      root.querySelector('[data-review-result]').textContent = '';
      root.querySelector('[data-review-actions]').hidden = true;
      root.querySelector('[data-review-share-status]').textContent = '';
      var heading = profile.firstName ? profile.firstName + "'s nutrition starting point" : 'Your nutrition starting point';
      root.querySelector('[data-plan-heading]').textContent = heading;
      root.querySelector('[data-plan-subheading]').textContent = language.copy;
      root.querySelector('[data-result-calories]').textContent = formatNumber(plan.calories);
      root.querySelector('[data-result-range]').textContent = 'Operate within ' + formatNumber(plan.rangeLow) + '-' + formatNumber(plan.rangeHigh) + ' kcal';
      root.querySelector('[data-result-protein]').textContent = plan.protein + 'g';
      root.querySelector('[data-result-carbs]').textContent = plan.carbohydrates + 'g';
      root.querySelector('[data-result-fat]').textContent = plan.fat + 'g';
      root.querySelector('[data-protein-note]').textContent = 'About ' + plan.mealProtein + 'g across ' + profile.meals + ' feedings';
      root.querySelector('[data-brief-title]').textContent = language.brief;
      root.querySelector('[data-brief-copy]').textContent = language.copy;

      var operatingOrders = [
        { title: 'Hold the calorie range', copy: 'Aim for ' + formatNumber(plan.calories) + ' kcal, with a working range of ' + formatNumber(plan.rangeLow) + '-' + formatNumber(plan.rangeHigh) + '. Do not react to one high or low day.' },
        { title: 'Distribute protein', copy: 'Reach ' + plan.protein + 'g daily. A practical split is about ' + plan.mealProtein + 'g across ' + profile.meals + ' feedings.' },
        { title: 'Match the method to your life', copy: trackingOrder(plan) }
      ];
      renderCards(root.querySelector('[data-operating-orders]'), operatingOrders, 'ccn-order');
      renderCalorieCycling(plan);

      var watch = root.querySelector('[data-watch-items]');
      watch.textContent = '';
      var watchTitle = document.createElement('h4');
      watchTitle.textContent = 'Watch and report';
      var watchList = document.createElement('ul');
      var watchItems = plan.warnings.concat([
        'Persistent fatigue, poor sleep, falling performance, low mood or loss of normal physiological function are reasons to review the plan.',
        'If weight moves unexpectedly for two honest weeks, use the Weekly review rather than guessing.'
      ]);
      watchItems.forEach(function (warning) {
        var item = document.createElement('li');
        item.textContent = warning;
        watchList.appendChild(item);
      });
      watch.append(watchTitle, watchList);

      var mealCopy;
      if (profile.trackingStyle === 'portions') {
        mealCopy = 'Use the plate and hand portions below. Keep the meals recognisable and repeatable rather than chasing perfect numbers.';
      } else {
        mealCopy = 'Your daily totals matter most. These meal anchors make the totals easier to hit without eating like a spreadsheet.';
      }
      root.querySelector('[data-meal-copy]').textContent = mealCopy;

      var cookingCopy = {
        minimal: 'Use ready-to-eat proteins, microwave grains, frozen vegetables and fruit. Convenience is allowed; structure still matters.',
        moderate: 'Cook simple protein, carbohydrate and vegetable components twice each week, then assemble meals quickly.',
        batch: 'Batch cook two proteins, two carbohydrate bases and a large vegetable tray. Freeze spare portions before the week gets busy.'
      };
      var mealStructures = [
        { title: 'Protein anchor', copy: plan.mealProtein + 'g protein per feeding on average. Choose the protein first, then build the rest of the meal.' },
        { title: 'Training carbohydrate', copy: 'Place a larger share of the ' + plan.carbohydrates + 'g daily carbohydrate target before and after training.' },
        { title: 'Plant and fibre base', copy: 'Work toward at least five fruit and vegetable portions and roughly 30g fibre across the day.' },
        { title: 'Preparation method', copy: cookingCopy[profile.cookingTime] || cookingCopy.moderate }
      ];
      renderCards(root.querySelector('[data-meal-structure]'), mealStructures, 'ccn-meal');
      renderFoodBank(plan);
      renderProteinReference(plan);
      renderMealBuilder(plan);

      var restrictionsNote = root.querySelector('[data-restrictions-note]');
      if (profile.restrictions) {
        restrictionsNote.hidden = false;
        restrictionsNote.textContent = 'Your note: ' + profile.restrictions + '. Keep all choices compatible with diagnosed allergies and clinician advice.';
      } else {
        restrictionsNote.hidden = true;
        restrictionsNote.textContent = '';
      }

      var preProtein = clamp(roundToFive(profile.weightKg * 0.3), 20, 40);
      var preCarb = clamp(roundToFive(profile.weightKg * (profile.longSessions ? 0.8 : 0.5)), 25, 100);
      var postCarb = clamp(roundToFive(profile.weightKg * (profile.longSessions ? 1 : 0.6)), 30, 120);
      var trainingTime = profile.trainingTime === 'varies' ? 'before the session' : 'before your ' + profile.trainingTime + ' session';
      var fuelItems;

      if (profile.trainingDays === 0) {
        fuelItems = [
          { title: 'Daily nutrition first', copy: 'No session-specific strategy is needed. Hit the daily targets, regular meals and hydration baseline.' }
        ];
      } else {
        fuelItems = [
          { title: 'Before training', copy: 'About 1-3 hours ' + trainingTime + ', aim for roughly ' + preCarb + 'g carbohydrate and ' + preProtein + 'g protein. Keep fat and fibre lower if your stomach is sensitive.' },
          { title: 'During training', copy: profile.longSessions > 0 ? 'For sessions over 75 minutes, start with 30-60g carbohydrate per hour plus fluid. Longer endurance work may need more only after gut training.' : 'For most sessions under 75 minutes, water and the day\'s normal meals are enough. Carbohydrate during training is optional.' },
          { title: 'After training', copy: 'Within the next normal meal, reach ' + preProtein + 'g protein and around ' + postCarb + 'g carbohydrate when recovery time is short or another session follows.' },
          { title: 'Hydration', copy: 'Start sessions hydrated, use pale-yellow urine as a practical check, and increase fluids in heat or long-duration work. Replace very salty sweat with food and electrolytes as needed.' }
        ];
      }
      renderCards(root.querySelector('[data-fuel-plan]'), fuelItems, 'ccn-fuel');
      renderHabits(plan);

      var reviewLabels = root.querySelectorAll('.ccn-review label');
      if (reviewLabels.length >= 2) {
        var unit = profile.units === 'imperial' ? 'lb' : 'kg';
        reviewLabels[0].textContent = 'Previous weekly average (' + unit + ')';
        reviewLabels[1].textContent = 'Current weekly average (' + unit + ')';
      }
      var cycleContext = root.querySelector('[data-cycle-context]');
      cycleContext.hidden = profile.sex !== 'female';
      if (cycleContext.hidden) cycleContext.querySelector('input').checked = false;
      renderMeasurementTracker(plan);
    }

    function renderClinicalHold(plan) {
      var message = plan.reasons.join(' ');
      root.querySelector('[data-plan-heading]').textContent = 'Specialist review required';
      root.querySelector('[data-plan-subheading]').textContent = 'The safe next step is a human review, not a generic target.';
      root.querySelector('[data-clinical-message]').textContent = message + ' Speak to your doctor or a registered dietitian, and bring the outcome to your Complete Commando coach.';
    }

    function serialiseForm() {
      var data = {};
      Array.prototype.forEach.call(nutritionForm.elements, function (element) {
        if (!element.name) return;
        if (element.type === 'radio') {
          if (element.checked) data[element.name] = element.value;
          return;
        }
        if (element.type === 'checkbox') {
          data[element.name] = element.checked;
          return;
        }
        data[element.name] = element.value;
      });
      return data;
    }

    function restoreForm(data) {
      Object.keys(data).forEach(function (name) {
        var elements = nutritionForm.querySelectorAll('[name="' + name + '"]');
        elements.forEach(function (element) {
          if (element.type === 'radio') element.checked = element.value === data[name];
          else if (element.type === 'checkbox') element.checked = Boolean(data[name]);
          else element.value = data[name];
        });
      });
      updateUnits(checkedValue('units') || 'metric', false);
      updateGoalControls();
    }

    function showPlan(plan, fromRestore) {
      lastPlan = plan;
      workspace.hidden = true;
      results.hidden = false;
      clinicalHold.hidden = !plan.clinical;
      standardPlan.hidden = plan.clinical;

      if (plan.clinical) renderClinicalHold(plan);
      else renderStandardPlan(plan);

      selectPlanTab('brief');
      if (!fromRestore) {
        var saved = writeStorage(window.localStorage, PROFILE_KEY, JSON.stringify(serialiseForm()));
        saveStatus.textContent = saved ? 'Plan saved on this device.' : 'Plan created. This browser blocked local saving.';
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        saveStatus.textContent = 'Saved plan loaded from this device.';
      }
    }

    function buildPlan(fromRestore) {
      if (!fromRestore && !validateAllSteps()) return;
      var profile = collectProfile();
      var plan = calculatePlan(profile);
      showPlan(plan, fromRestore);
    }

    nutritionForm.addEventListener('submit', function (event) {
      event.preventDefault();
      buildPlan(false);
    });

    root.querySelector('[data-edit-plan]').addEventListener('click', function () {
      results.hidden = true;
      workspace.hidden = false;
      showStep(1);
      workspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function selectPlanTab(name) {
      root.querySelectorAll('[data-plan-tab]').forEach(function (button) {
        var selected = button.dataset.planTab === name;
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.setAttribute('tabindex', selected ? '0' : '-1');
      });
      root.querySelectorAll('[data-plan-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.planPanel !== name;
      });
    }

    var planTabs = Array.prototype.slice.call(root.querySelectorAll('[data-plan-tab]'));
    planTabs.forEach(function (button) {
      button.addEventListener('click', function () {
        selectPlanTab(button.dataset.planTab);
      });
      button.addEventListener('keydown', function (event) {
        var currentIndex = planTabs.indexOf(button);
        var nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % planTabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + planTabs.length) % planTabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = planTabs.length - 1;
        else return;
        event.preventDefault();
        selectPlanTab(planTabs[nextIndex].dataset.planTab);
        planTabs[nextIndex].focus();
      });
    });

    root.querySelector('[data-open-review]').addEventListener('click', function () {
      selectPlanTab('review');
      root.querySelector('[data-plan-nav]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    async function copyText(text, statusElement, successMessage, failureMessage) {
      try {
        await navigator.clipboard.writeText(text);
        statusElement.textContent = successMessage;
        return;
      } catch (error) {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        var copied = document.execCommand('copy');
        textarea.remove();
        statusElement.textContent = copied ? successMessage : failureMessage;
      }
    }

    function planAsText(plan) {
      if (!plan) return '';
      if (plan.clinical) return 'Complete Commando Nutrition Coach\nSpecialist review required\n' + plan.reasons.join(' ');

      var language = goalLanguage(plan);
      var habits = habitPlan(plan).map(function (habit, index) {
        return (index + 1) + '. ' + habit.title + ': ' + habit.copy;
      }).join('\n');

      return [
        'COMPLETE COMMANDO NUTRITION PLAN',
        language.label,
        '',
        'Calories: ' + plan.calories + ' kcal (range ' + plan.rangeLow + '-' + plan.rangeHigh + ')',
        'Estimated maintenance: ' + plan.maintenance + ' kcal',
        'Protein: ' + plan.protein + 'g',
        'Carbohydrate: ' + plan.carbohydrates + 'g',
        'Fat: ' + plan.fat + 'g',
        'Protein per feeding: about ' + plan.mealProtein + 'g across ' + plan.profile.meals + ' feedings',
        '',
        language.copy,
        '',
        'PRIORITY HABITS',
        habits,
        '',
        'Use weekly average bodyweight, adherence, hunger and performance to adjust. This is educational coaching support, not medical advice.'
      ].join('\n');
    }

    root.querySelector('[data-copy-plan]').addEventListener('click', async function () {
      var text = planAsText(lastPlan);
      if (!text) return;
      await copyText(text, saveStatus, 'Plan copied.', 'Copy was blocked. Use Print to keep the plan.');
    });

    root.querySelector('[data-print-plan]').addEventListener('click', function () {
      window.print();
    });

    function weeklyReviewAsText(review) {
      if (!review || !lastPlan || lastPlan.clinical) return '';
      var name = lastPlan.profile.firstName || 'Member';
      var unit = lastPlan.profile.units === 'imperial' ? 'lb' : 'kg';
      var performanceLabels = { better: 'Improving', same: 'Stable', worse: 'Declining' };
      return [
        'COMPLETE COMMANDO WEEKLY NUTRITION REVIEW',
        'Member: ' + name,
        'Date: ' + review.date,
        '',
        'CURRENT PLAN',
        'Calories: ' + lastPlan.calories + ' kcal (range ' + lastPlan.rangeLow + '-' + lastPlan.rangeHigh + ')',
        'Protein: ' + lastPlan.protein + 'g',
        'Carbohydrate: ' + lastPlan.carbohydrates + 'g',
        'Fat: ' + lastPlan.fat + 'g',
        '',
        'WEEKLY CHECK-IN',
        'Average bodyweight: ' + review.previous + unit + ' to ' + review.current + unit + ' (' + (review.changePercent > 0 ? '+' : '') + review.changePercent.toFixed(2) + '%)',
        'Plan adherence: ' + review.adherence + '%',
        'Hunger: ' + review.hunger + '/10',
        'Training performance: ' + (performanceLabels[review.performance] || review.performance),
        'Scale context: ' + (review.contextCopy || 'None recorded'),
        '',
        'COACHING DECISION',
        review.actionTitle,
        review.actionCopy
      ].join('\n');
    }

    root.querySelector('[data-weekly-review]').addEventListener('submit', function (event) {
      event.preventDefault();
      if (!lastPlan || lastPlan.clinical) return;

      var reviewForm = event.currentTarget;
      var previous = Number(reviewForm.elements.previousAverage.value);
      var current = Number(reviewForm.elements.currentAverage.value);
      var adherence = Number(reviewForm.elements.adherence.value);
      var hunger = Number(reviewForm.elements.hunger.value);
      var performance = reviewForm.elements.performance.value;
      var contexts = Array.prototype.map.call(reviewForm.querySelectorAll('input[name="reviewContext"]:checked'), function (input) {
        return input.value;
      });
      var error = root.querySelector('[data-review-error]');
      var output = root.querySelector('[data-review-result]');
      var reviewActions = root.querySelector('[data-review-actions]');
      error.textContent = '';
      reviewActions.hidden = true;
      root.querySelector('[data-review-share-status]').textContent = '';
      lastReview = null;

      if (!inRange(previous, 35, 660) || !inRange(current, 35, 660) || !inRange(adherence, 0, 100) || !inRange(hunger, 1, 10)) {
        error.textContent = 'Enter both weekly averages, adherence and hunger before reviewing.';
        return;
      }

      var changePercent = ((current - previous) / previous) * 100;
      var goal = lastPlan.profile.goal;
      var actionTitle = 'Hold the plan.';
      var actionCopy = 'The trend is inside the useful range. Keep the same calories for another week.';
      var calorieAction = 0;

      if (adherence < 80) {
        actionTitle = 'Do not change calories yet.';
        actionCopy = 'Adherence is below 80%. Tighten execution for one week so the next decision is based on the plan rather than noise.';
      } else if (goal === 'loss') {
        if (changePercent > -0.25) {
          calorieAction = -100;
          actionTitle = 'Reduce by about 100 kcal.';
          actionCopy = 'Fat-loss progress is slower than the working range despite good adherence. Remove 100 kcal, preferably from carbohydrate or fat, then hold for another week.';
        } else if (changePercent < -0.75 && (hunger >= 8 || performance === 'worse')) {
          calorieAction = 150;
          actionTitle = 'Add about 150 kcal.';
          actionCopy = 'Weight is falling quickly and recovery signals are poor. Add 150 kcal, prioritising carbohydrate around training.';
        } else if (changePercent < -1) {
          calorieAction = 100;
          actionTitle = 'Add about 100 kcal.';
          actionCopy = 'The rate is faster than needed. Add 100 kcal and protect performance and lean mass.';
        }
      } else if (goal === 'build') {
        if (changePercent < 0.10) {
          calorieAction = 100;
          actionTitle = 'Add about 100 kcal.';
          actionCopy = 'Bodyweight is not rising despite good adherence. Add 100 kcal, mainly from carbohydrate, and review again next week.';
        } else if (changePercent > 0.50) {
          calorieAction = -100;
          actionTitle = 'Reduce by about 100 kcal.';
          actionCopy = 'Bodyweight is rising faster than a controlled gaining phase needs. Remove 100 kcal and monitor waist and performance.';
        }
      } else {
        if (changePercent > 0.25) {
          calorieAction = -100;
          actionTitle = 'Reduce by about 100 kcal.';
          actionCopy = 'The maintenance trend is moving upward. Remove 100 kcal and reassess after another honest week.';
        } else if (changePercent < -0.25) {
          calorieAction = 100;
          actionTitle = 'Add about 100 kcal.';
          actionCopy = 'The maintenance trend is moving downward. Add 100 kcal, prioritising training fuel.';
        }
      }

      var contextLabels = {
        cycle: 'menstrual-cycle timing',
        sodium: 'unusually salty or high-carbohydrate meals',
        heat: 'heat or altered hydration',
        training: 'hard training or muscle soreness',
        travel: 'travel, sleep or stress disruption',
        digestion: 'changed digestion'
      };
      var contextCopy = contexts.map(function (context) { return contextLabels[context]; }).filter(Boolean).join(', ');
      var protectFuelIncrease = goal === 'loss' && calorieAction > 0 && (changePercent < -1 || hunger >= 8 || performance === 'worse');
      if (contexts.length && adherence >= 80 && calorieAction !== 0 && Math.abs(changePercent) < 1.5 && !protectFuelIncrease) {
        calorieAction = 0;
        actionTitle = 'Hold calories and collect another week.';
        actionCopy = 'The scale trend suggests an adjustment, but you also recorded ' + contextCopy + '. Keep calories unchanged and collect another consistent weekly average before acting. Compare the same menstrual-cycle phase when relevant.';
      } else if (contexts.length) {
        actionCopy += ' Context recorded: ' + contextCopy + '. Keep weigh-in conditions consistent and avoid interpreting a short-term fluid or digestion shift as body-fat change.';
      }

      if (performance === 'worse' && calorieAction <= 0 && adherence >= 80) {
        actionCopy += ' Because training is declining, also review sleep, carbohydrate timing and total training load with your coach.';
      }

      output.textContent = '';
      var title = document.createElement('h4');
      title.textContent = actionTitle;
      var trend = document.createElement('p');
      var trendValue = document.createElement('strong');
      trendValue.textContent = 'Weekly change: ' + (changePercent > 0 ? '+' : '') + changePercent.toFixed(2) + '%. ';
      trend.append(trendValue, document.createTextNode(actionCopy));
      output.append(title, trend);
      output.hidden = false;

      lastReview = {
        date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }),
        previous: previous,
        current: current,
        adherence: adherence,
        hunger: hunger,
        performance: performance,
        contextCopy: contextCopy,
        changePercent: changePercent,
        actionTitle: actionTitle,
        actionCopy: actionCopy
      };
      var reviewText = weeklyReviewAsText(lastReview);
      var memberName = lastPlan.profile.firstName || 'Member';
      root.querySelector('[data-email-review]').href = 'mailto:info@completecommando.com?subject=' + encodeURIComponent('Weekly nutrition review - ' + memberName) + '&body=' + encodeURIComponent(reviewText);
      reviewActions.hidden = false;
    });

    root.querySelector('[data-copy-review]').addEventListener('click', async function () {
      var reviewText = weeklyReviewAsText(lastReview);
      if (!reviewText) return;
      await copyText(
        reviewText,
        root.querySelector('[data-review-share-status]'),
        'Weekly report copied. Send it to your coach.',
        'Copy was blocked. Use Email report to coach instead.'
      );
    });

    root.querySelector('[data-measurement-form]').addEventListener('submit', function (event) {
      event.preventDefault();
      if (!lastPlan || lastPlan.clinical) return;

      var form = event.currentTarget;
      var units = lastPlan.profile.units;
      var date = form.elements.measurementDate.value;
      var names = ['waist', 'chest', 'hips', 'upperArm', 'thigh'];
      var values = {};
      var error = root.querySelector('[data-measurement-error]');
      var status = root.querySelector('[data-measurement-status]');
      error.textContent = '';
      status.textContent = '';

      names.forEach(function (name) {
        values[name] = form.elements[name].value === '' ? 0 : Number(form.elements[name].value);
      });

      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || date > localDateValue()) {
        error.textContent = 'Choose today or an earlier measurement date.';
        return;
      }

      var minimum = units === 'imperial' ? 8 : 20;
      var maximum = units === 'imperial' ? 120 : 300;
      if (!inRange(values.waist, minimum, maximum)) {
        error.textContent = 'Enter a valid waist measurement in ' + (units === 'imperial' ? 'inches' : 'centimetres') + '.';
        return;
      }

      var optionalBoundsCm = {
        chest: [20, 300],
        hips: [20, 300],
        upperArm: [10, 100],
        thigh: [10, 150]
      };
      var optionalValid = names.slice(1).every(function (name) {
        var bounds = optionalBoundsCm[name];
        var minimumValue = units === 'imperial' ? bounds[0] / 2.54 : bounds[0];
        var maximumValue = units === 'imperial' ? bounds[1] / 2.54 : bounds[1];
        return values[name] === 0 || inRange(values[name], minimumValue, maximumValue);
      });
      if (!optionalValid) {
        error.textContent = 'Check the optional body measurements before saving.';
        return;
      }

      var entry = {
        date: date,
        waistCm: measurementToCm(values.waist, units),
        chestCm: measurementToCm(values.chest, units),
        hipsCm: measurementToCm(values.hips, units),
        upperArmCm: measurementToCm(values.upperArm, units),
        thighCm: measurementToCm(values.thigh, units)
      };
      measurementEntries = measurementEntries.filter(function (item) { return item.date !== date; });
      measurementEntries.unshift(entry);
      measurementEntries.sort(function (a, b) { return b.date.localeCompare(a.date); });
      measurementEntries = measurementEntries.slice(0, 24);
      var saved = saveMeasurements();
      status.textContent = saved ? 'Measurements saved on this device.' : 'Measurements added, but this browser blocked local saving.';
      renderMeasurementTracker(lastPlan);
    });

    root.querySelector('[data-clear-measurements]').addEventListener('click', function () {
      if (!window.confirm('Clear all body measurements saved in this browser?')) return;
      measurementEntries = [];
      removeStorage(window.localStorage, MEASUREMENTS_KEY);
      root.querySelector('[data-measurement-status]').textContent = 'Measurement history cleared.';
      renderMeasurementTracker(lastPlan);
    });

    updateGoalControls();
    updateUnits(checkedValue('units') || 'metric', false);
    showStep(1);

    showApp();
  });
})();
